"use strict";

var cx = require("classnames");
// TODO: Remove this JSX from components/index.js

var _ = require("underscore");
var cx = require("classnames");
var Reflux = require("reflux");
var UserAvatar = require("app/shared/components/User/user-avatar");

var UserSelectBoxActions = require("app/screens/Activity/actions/user-select-box-actions");
var UserSelectBoxStore = require("app/screens/Activity/stores/user-select-box-store");
var agendorAPI = require("app/util/api/agendor-api");
var navigateKeys = [38, 40, 13, 27];

var MultiActionStore = require("app/util/flux/multi-action-store");
var KeyNavigatorMixin = require("app/util/browser/key-navigator").mixin;
var lockScroll = require("app/util/browser/scroll");

var UserSelectBox = React.createClass({
  mixins: [Reflux.ListenerMixin, MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      userSelectBoxStore: UserSelectBoxStore,
      userSelectBoxActions: UserSelectBoxActions
    };
  },
  getInitialState: function(){
    var initialState = this.userSelectBoxStore.state;
    return initialState;
  },
  componentDidMount: function(){
    this.listenTo(this.userSelectBoxStore, this.setState);
    this.userSelectBoxActions.loadUsers(this.props.selectedUsers || this.state.users);
  },
  onParentClose: function(){},
  render: function render(){
    var users = [];

    _.each(this.state.users, function(user, i) {
      if(!user.avatarURL) {
        user.avatarURL = user.avatar&&user.avatar["70x70"] ? user.avatar["70x70"] : null;
      }
      if(!user.hidden) {
        users.push(<UserSelectBoxUser {...user} instanceKey={this.props.instanceKey} focusId={this.state.focusId} key={user.id} />);
      }
    }.bind(this));

    if (this.state.users.length==0) {
      users = <em>Carregando...</em>;
    }
    else if (users.length==0) {
      users = <em>Nenhum usuário encontrado</em>;
    }

    var classes = cx(this.props.classes, "userSelectBox");

    return (
      <div className={classes}>
        <UserSelectBoxInput {...this.props} />
        <UserSelectBoxList users={users} />
      </div>
    );
  }
});

var UserSelectBoxInput = React.createClass({
  mixins: [MultiActionStore.mixin, KeyNavigatorMixin],
  getActionsAndStores: function(){
    return {
      userSelectBoxActions: UserSelectBoxActions
    };
  },
  search: function(e){
    if(navigateKeys.indexOf(e.keyCode)!=-1){
      e.preventDefault();
    } else {
      this.userSelectBoxActions.search(e.target.value);
    }
  },
  keyNavigate: function(keyCode){
    if(navigateKeys.indexOf(keyCode)!=-1){
      this.userSelectBoxActions.keyNavigate(keyCode);
    }
  },
  render: function() {
    return (
      <div className="form-group mb-10">
        <input className="form-control input-sm userSelectBox-search" onKeyDown={this.onKeyDown} onChange={this.search} type="text" placeholder="Procurar" />
      </div>
    );
  }
});

var UserSelectBoxList = React.createClass({
  componentDidMount: function() {
    this._userSelectList.addEventListener("wheel", this.handleScroll);
  },
  componentWillUnmount: function() {
    this._userSelectList.removeEventListener("wheel", this.handleScroll);
  },
  handleScroll: function(e) {
    return lockScroll(this._userSelectList, e);
  },
  render: function() {
    return (
      <div className="userSelectBox-list"
        ref={(userSelectList) => this._userSelectList = userSelectList} >
        {this.props.users}
      </div>
    );
  }
});

var UserSelectBoxUser = React.createClass({
  mixins: [MultiActionStore.mixin],
  getActionsAndStores: function(){
    return {
      userSelectBoxActions: UserSelectBoxActions
    };
  },
  check: function(){
    this.userSelectBoxActions.check(this.props.id, !this.props.checked);
  },
  render: function render(){
    var classes = cx({
      "userSelectBox-user": true,
      "focus": (this.props.id==this.props.focusId),
      "fs-12": true
    });
    return (
      <label className={classes} onClick={this.check} >
        <input readOnly checked={this.props.checked} className="userSelectBox-checkbox d-n" type="checkbox" />
        <div>
          <UserAvatar className="f-l ovf-h" name={this.props.name} avatarURL={this.props.avatarURL} key={this.props.id} size="small" />
          <span className="f-l truncate-sentence userSelectBox-userName">{this.props.name}</span>
          <em className="f-l truncate-sentence userSelectBox-userJob">{this.props.position}</em>
          <div className="checkbox-square"></div>
        </div>
        <div className="u-clear"></div>
      </label>
    );
  }
});

module.exports = UserSelectBox;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/user-select-box.jsx